import React, { useEffect, useRef } from 'react';
import { XIcon } from 'lucide-react';
interface LegalModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function LegalModal({
  isOpen,
  onClose,
  title,
  children
}: LegalModalProps) {
  const modalRef = useRef<HTMLDivElement>(null);
  const closeButtonRef = useRef<HTMLButtonElement>(null);
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
      closeButtonRef.current?.focus();
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);
  useEffect(() => {
    function handleKeyDown(e: KeyboardEvent) {
      if (e.key === 'Escape' && isOpen) {
        onClose();
      }
    }
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [isOpen, onClose]);
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4" role="dialog" aria-modal="true" aria-labelledby="legal-modal-title" data-id="element-119">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={onClose} aria-hidden="true" data-id="element-120" />

      {/* Modal */}
      <div ref={modalRef} className="relative bg-white rounded-2xl shadow-2xl w-full max-w-2xl max-h-[85vh] flex flex-col overflow-hidden animate-modal-in" data-id="element-121">
        {/* Header */}
        <div className="flex items-center justify-between px-6 py-5 border-b border-gray-100 flex-shrink-0" data-id="element-122">
          <h2 id="legal-modal-title" className="text-xl md:text-2xl font-bold text-[#1B2A4A]" data-id="element-123">
            {title}
          </h2>
          <button ref={closeButtonRef} onClick={onClose} className="w-10 h-10 flex items-center justify-center rounded-full hover:bg-gray-100 transition-colors focus:outline-none focus:ring-2 focus:ring-[#1B2A4A]/30" aria-label="Cerrar" data-id="element-124">
            <XIcon className="w-5 h-5 text-gray-500" data-id="element-125" />
          </button>
        </div>

        {/* Content */}
        <div className="px-6 py-6 overflow-y-auto flex-1 text-gray-700 text-base leading-relaxed space-y-4" data-id="element-126">
          {children}
        </div>

        {/* Footer */}
        <div className="px-6 py-4 border-t border-gray-100 flex-shrink-0" data-id="element-127">
          <button onClick={onClose} className="w-full py-3 bg-[#1B2A4A] hover:bg-[#243558] text-white font-semibold rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-[#1B2A4A]/40" data-id="element-128">
            Cerrar
          </button>
        </div>
      </div>
    </div>;
}